export default __webpack_public_path__ + "static/media/arrow-down.3b95c4b8.svg";